import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  CHECK_SURVEY_REQUEST: '',
  CHECK_SURVEY_SUCCESS: '',
  CHECK_SURVEY_FAILURE: '',

  GET_SURVEY_QUESTIONS_REQUEST: '',
  GET_SURVEY_QUESTIONS_SUCCESS: '',
  GET_SURVEY_QUESTIONS_FAILURE: '',

  SAVE_SURVEY_REQUEST: '',
  SAVE_SURVEY_SUCCESS: '',
  SAVE_SURVEY_FAILURE: '',
};

types = setStoreTypeValues(types, 'authSurvey');

export default types;
